import React, { createRef, useEffect, useState } from "react"
import ReactDOM from "react-dom"
import { useDispatch } from "react-redux"
import { addOverlay, removeOverlay } from "../Actions/Overlay.action"

export default ({ id, duration = "0.2s", from = "right", className, open, onClosed, showCloseButton = true, children, header, footer}) => {
    const [slideIn, setSlideIn] = useState()
    const [timeoutId, setTimeoutId] = useState()
    const ref = createRef()
    const dispatch = useDispatch()

    if(!id)
        throw new Error("A (side-menu wide) unique \"id\" must be passed to side menu component")

    const close = () => {
        // Just sets "slideIn" to false, which triggers the animation to close it
        setSlideIn(false)
    }

    useEffect(() => {
        if(!slideIn) {
            // If not slide in, slide out :^)
            if(timeoutId) {
                // Clear previous timeout to avoid animation delay bug
                clearTimeout(timeoutId)
            }

            var newTimeoutId = setTimeout(() => {
                setTimeoutId(undefined)
                onClosed && onClosed()
            }, duration.substr(0, duration.length-1) * 1000)

            setTimeoutId(newTimeoutId)
            dispatch(removeOverlay(id))
        }
    }, [slideIn])

    useEffect(() => {
        // Triggered every time "open" is changed, initially as well
        // Timeout to not trigger on the same frame as the render, to enable the slide-in
        setTimeout(() => setSlideIn(open), 1);

        if(open) {
            dispatch(addOverlay(id, close))
        }
    }, [open])
    
    return open 
        ? ReactDOM.createPortal(
            <div className={"side-menu" + (slideIn ? " side-menu--open" : "") + (" from-" + from) + (className ? " " + className : "")} ref={ref} style={{transitionDuration: duration}}>
                {header && <div className="side-menu__header">
                    {header}
                    {showCloseButton && <div className="side-menu__close-button" onClick={close}><i className="fas fa-times"></i></div> }
                </div>}
                <div className="side-menu__content">
                    {children}
                </div>
                {footer && <div className="side-menu__footer">
                    {footer}
                </div>}
            </div>, 
            document.body
        )
        : null
}